import React, {useEffect, useState} from 'react'
import styles from './calendar-style.module.css'
import { getEventsInRange } from '../firebase/firebase'
import { ReactComponent as ChautauquaArrowSVG } from './chautauqua-arrow.svg';
import { Calendar } from './Calendar';
import CalendarFilter from './CalendarFilter';
import DetailsViewer from './DetailsViewer';
import { useSearchParams } from 'react-router-dom';

const currentYear = new Date().getFullYear();
function getMonthTitle(month, year) {
    let monthName = "";
    switch (month) {
        case 0: monthName = "January"; break;
        case 1: monthName = "February"; break;
        case 2: monthName = "March"; break;
        case 3: monthName = "April"; break;
        case 4: monthName = "May"; break;
        case 5: monthName = "June"; break;
        case 6: monthName = "July"; break;
        case 7: monthName = "August"; break;
        case 8: monthName = "September"; break;
        case 9: monthName = "October"; break;
        case 10: monthName = "November"; break;
        case 11: monthName = "December"; break;
        default: break;
    }

    monthName += " " + year;

    return monthName;
}

function incrementMonth(month, setMonth, year, setYear) {
    if(month === 11) {
        setMonth(0);
        setYear(year + 1);
    } else
        setMonth(month + 1)
}

function decrementMonth(month, setMonth, year, setYear) {
    if(month === 0) {
        setMonth(11);
        setYear(year - 1);
    } else
        setMonth(month - 1)
}

function CalendarPage({ setShowNavBar }) {
    
    const [searchParams, setSearchParams] = useSearchParams();

    let initialMonth = Number(searchParams.get('month') ?? new Date().getMonth());
    let initialYear = Number(searchParams.get('year') ?? currentYear);

    const [events, setEvents] = useState([]);
    const [focusedEvent, setFocusedEvent] = useState();
    const [visibleEventTypes, setVisibleEventTypes] = useState({'camp': true, 'retreat': true, 'day_event': true, 'reservation': true});
    const [dropdownVisibily, setDropdownVisibily] = useState(false);
    const [locationsFilters, setLocationFilters] = useState([]);
    const [month, setMonth] = useState(initialMonth);
    const [year, setYear] = useState(currentYear);

    if(initialMonth !== month)
        setMonth(initialMonth);

    if(initialYear !== year)
        setYear(initialYear);

    const updateFocusedEvent = (event) => setFocusedEvent((event?.id === focusedEvent?.id) ? null : event);


    useEffect(() => setShowNavBar(true));

    useEffect(() => {
        async function getList() {
            return await getEventsInRange(new Date(year, month, 1), new Date(year, month + 1, 0, 23, 59));   
        }

        getList().then( (events) => {
            setEvents(events);
        });
    }, [month, year]);

    function onClick(ev) {
        const menu = document.querySelector('#'+styles.location_checkboxes);
        const selector = document.querySelector('#'+styles.location_selector);
        if(!menu.contains(ev.target) && !selector.contains(ev.target))
            setDropdownVisibily(false);
    }

    function updateMonth(month) {
        searchParams.set('month', month);
        setSearchParams(searchParams);
        setMonth(month);
    }

    function updateYear(year) {
        searchParams.set('year', year);
        setSearchParams(searchParams);
        setYear(year);
    }

    return (
        <div className={styles.page} onClick={(ev)=>onClick(ev)}>
            <div className={styles.view}>
                <div className={styles.controls}>
                    <div onClick={() => decrementMonth(month, updateMonth, year, updateYear)}>
                        <ChautauquaArrowSVG fill="#000000" id={styles.left}/>
                    </div>
                    <h1>{getMonthTitle(month, year)}</h1>
                    <div onClick={() => incrementMonth(month, updateMonth, year, updateYear)}>
                        <ChautauquaArrowSVG fill="#000000" id={styles.right}/>
                    </div>
                </div>                
                <Calendar month={month} events={events} visibleEventTypes={visibleEventTypes} locationsFilters={locationsFilters} focusedEvent={focusedEvent} setFocusedEvent={updateFocusedEvent}></Calendar>
            </div>
            <CalendarFilter setVisibleEventTypes={setVisibleEventTypes} visibleEventTypes = {visibleEventTypes}
                    locationsFilters={locationsFilters} setLocationFilters={setLocationFilters}
                    dropdownVisibily={dropdownVisibily} setDropdownVisibily={setDropdownVisibily}></CalendarFilter>

            <DetailsViewer event={focusedEvent} ></DetailsViewer>            
        </div>
    )
}

export default CalendarPage;